import React from "react";

import { Alert } from "~/components/alert";

import { DocLink } from "../../../../../../../components/react/docLink/DocLink";
import { SILENCING_DOC_LINK_SLUG } from "../../silencing-doc-link-slug";

export function PastRuleAlert() {
	return (
		<Alert variant="warning">
			<strong className="font-semibold">You’re looking at a past silencing rule</strong> and, therefore, it cannot be
			removed. To learn more about unmuting monitors,{" "}
			<DocLink capture="noop" slug={SILENCING_DOC_LINK_SLUG}>
				check out our docs
			</DocLink>
			.
		</Alert>
	);
}
